module.exports = __webpack_public_path__ + "img/4.69243902.jpg";